import type { EventType } from './event.interface';

export interface cv_EventType {
    C_EventType_key: number;
    C_VocabularySource_key: number | null;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    Event: EventType[];
    EventType: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    Label: string;
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
}
